export default __webpack_public_path__ + "static/media/zeroDeprecationCover.66939c05.svg";